import { useMemo } from 'react';

import { TFunc, useTranslation } from 'libs/i18n';
import { TableColumn } from 'libs/ui';

import { renderDate, renderMore, renderName, renderText } from './renders';
import { DocumentColumnArgs, DocumentItemType } from './types';

export const getColumns = (
  t: TFunc,
  {
    onClickOption,
    onClickName,
    editable = false,
    canDeleteAnyDocument = false,
  }: DocumentColumnArgs
): TableColumn<DocumentItemType>[] => [
  {
    field: 'number',
    title: '',
    width: 64,
    align: 'center',
    renderCell: (item) => renderText(item.number.toString()),
  },
  {
    field: 'name',
    title: t('components.documentsTable.columns.name'),
    flex: 1,
    renderCell: (item) => renderName(item, onClickName),
  },
  {
    field: 'createdAt',
    title: t('components.documentsTable.columns.date'),
    flex: 1,
    renderCell: (item) => renderDate(item),
  },
  {
    field: 'more' as 'number',
    title: '',
    width: 56,
    align: 'center',
    renderCell: (item) =>
      renderMore(t, item, editable, canDeleteAnyDocument, onClickOption),
  },
];

export const useColumns = (args: DocumentColumnArgs) => {
  const { t } = useTranslation();

  return useMemo(() => getColumns(t, args), [args, t]);
};
